import { Text } from "../../../text";
import { ActionIcon } from "../../../action-icon";
import { Icon } from "../../../icon";
import { faClockRotateLeft } from "@fortawesome/pro-regular-svg-icons";
import { ISidebarFetchMoreItemsProps } from "./sidebar-content.types";
import { kebabCase } from "lodash";
import { SidebarItemWrapper } from "./sidebar-item-wrapper";

/**
 * A clickable sidebar item that triggers loading of older or newer interactions.
 * @param {Function} props.onClick - Optional click handler to fetch more items.
 * @param {string} props.label - The display text for the fetch more button.
 * @param {SidebarItemType} props.type - The direction type (older or newer) affecting the icon orientation.
 * @param {boolean} props.isLoading - Optional flag indicating if more items are currently being loaded.
 * @returns {JSX.Element} The FetchMoreItems component.
 */
const FetchMoreItems = ({ onClick, label, type, isLoading }: ISidebarFetchMoreItemsProps) => {
    return (
        <SidebarItemWrapper
            onClick={isLoading ? undefined : onClick}
            data-testid={`fetch-more-interactions-button-${kebabCase(label)}`}
        >
            <ActionIcon loading={isLoading} bdrs="xxl" color="gray" variant="default" size="sm">
                <Icon flip={type === "newer" ? "horizontal" : undefined} icon={faClockRotateLeft} />
            </ActionIcon>
            <Text noWrap data-hide-on-sidebar-collapse size="sm">
                {label}
            </Text>
        </SidebarItemWrapper>
    );
};

export { FetchMoreItems };
